var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { attrs: { id: "main" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _vm.project
                ? _c("h1", [_vm._v(_vm._s(_vm.project.Info.title))])
                : _vm._e(),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "payment-method" }, [
                _vm.donation && !_vm.donation.paymentMethod == "boleto"
                  ? _c("h2", [_vm._v("Obrigado pela sua doação!")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.donation && _vm.donation.paymentMethod == "boleto"
                  ? _c("h2", [
                      _vm._v("Clique no link abaixo para ver o boleto")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.donation && _vm.donation.paymentMethod == "boleto"
                  ? _c(
                      "button",
                      {
                        staticClass: "btn",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.generateBoleto()
                          }
                        }
                      },
                      [_vm._v("Visualizar Boleto")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "share-project" }, [
                _c("h4", [_vm._v("Compartilhe essa Organização Social!")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Multiplique a chance de um projeto receber doações. Compartilhe sua doação."
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.shareFacebook()
                      }
                    }
                  },
                  [
                    _vm._v("Compartilhe este Projeto "),
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fab", "facebook"], size: "lg" }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading ? _c("Loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-tab" }, [
      _c("ul", [
        _c("li", [_vm._v("1 - Quanto quero doar")]),
        _vm._v(" "),
        _c("li", [_vm._v("2 - Meios de pagamento")]),
        _vm._v(" "),
        _c("li", { staticClass: "active" }, [_vm._v("3 - Compartilhar")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e6f2e75", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e6f2e75","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DonationFinish.vue
// module id = null
// module chunks = 